<template>
<div style="height: 100%;">
  <e-chart ref="env-chart" @initialized="onChartInitialized" />
</div>
</template>

<script>
import EChart from '../../../components/Charts/ECharts'

export default {
  name: 'EnvChart',
  components: {EChart},
  props: {
    envFactorMap: {
      required: true
    },
    data: {
      required: true
    },
    currentSiteId: {
      required: true
    }
  },
  computed: {
    envFactors () {
      return Object.values(this.envFactorMap)
    },
    filterData () {
      return this.data.filter(el => el.siteId === this.currentSiteId).map(el => Object.assign(el, {ts: new Date(el.dataTime).getTime()}))
    },
    tree () {
      let {filterData} = this
      if (!filterData.length) {
        return {
          data: {},
          dataTimes: []
        }
      }

      let endTs = new Date(filterData[filterData.length - 1].dataTime).getTime()
      let beginTs = new Date(filterData[0].dataTime).getTime()
      let tsStep = 300000
      let dateData = {}

      for (let ts = beginTs; ts <= endTs; ts += tsStep) {
        dateData[ts] = {
          dataTime: new Date(ts).format('YYYY/MM/DD HH:mm:ss'),
          stdUnit: '--',
          value: '--'
        }
      }

      let dataMap = filterData.reduce((map, el) => {
        if (!map[el.factorId]) {
          map[el.factorId] = {
            ...dateData
          }
        }

        let ts = new Date(el.dataTime).getTime()
        map[el.factorId][ts] = el

        return map
      }, {})

      return {
        data: dataMap,
        dataTimes: Object.values(dateData).map(el => new Date(el.dataTime).format('DD HH:mm'))
      }
    }
  },
  methods: {
    getYaxisMap (data) {
      return data.reduce((map, el) => {
        let unit = el.data[0] ? el.data[0].stdUnit : '--'
        let value = el.data.map(item => {
          if (item.value !== '--') {
            return item.value
          }
        }).filter(Boolean)

        if (!map[unit]) {
          map[unit] = {
            ...el,
            min: '',
            max: '',
            stdUnit: unit
          }
        }

        if (Math.min(...value) < map[unit].min || map[unit].min === '') {
          map[unit].min = Math.min(...value)
        }

        if (Math.max(...value) > map[unit].max || map[unit].max === '') {
          map[unit].max = Math.max(...value)
        }

        return map
      }, {})
    },
    render () {
      let {tree, envFactorMap} = this
      let chart = this.$refs['env-chart']

      let data = JSON.parse(JSON.stringify(tree.data))
      let newData = []
      if (data) {
        for (let key in data) {
          newData.push({
            name: envFactorMap[key] ? envFactorMap[key].name : '--',
            data: Object.values(data[key])
          })
        }
      }
      let yAxisMap = this.getYaxisMap(newData)

      let chartOpt = {
        backgroundColor: '#16233C',
        tooltip: {
          show: true,
          trigger: 'axis',
          appendToBody: true,
          formatter: function (param) {
            return `<div style="width: 200px;">
            <div style="margin: 0;font-weight: bold;">${param[0].data.dataTime ? param[0].data.dataTime : ''}</div>
  ${param.map(el => {
    let {data: {value, stdUnit}, marker, seriesName} = el
    return `
      <div style="width: 100%;margin: 0;">
        <p style="width: 100%;margin: 2px 5px;display: flex;justify-content: space-between; align-items: center;">
          <span style="display: inline-block;font-weight: bold;">${marker} ${seriesName}:</span>
          <span style="display: inline-block;">${value}${stdUnit ? ('(' + stdUnit + ')') : ''}</span>
        </p>
      </div>
    `
  }).join('')}
  </div>`
          }
        },
        grid: [{
          top: 55,
          right: 20,
          bottom: 50,
          left: 20,
          containLabel: true
        }],
        legend: {
          width: '80%',
          type: 'scroll',
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          type: 'category',
          data: tree.dataTimes,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgb(96, 98, 102)'
            }
          },
          axisLabel: {
            color: '#fff',
            fontFamily: 'Times New Roman'
          }
        },
        yAxis: Object.values(yAxisMap).length > 0 ? Object.values(yAxisMap).map((el, i) => {
          return {
            id: i,
            name: el.stdUnit === '--' ? '' : el.stdUnit,
            type: 'value',
            min: el.min - (el.min * 0.05) < 0 ? 0 : Math.floor(el.min - (el.min * 0.05)),
            max: Math.ceil(el.max + (el.max * 0.05)),
            nameGap: 10,
            offset: i > 1 ? (40 * (i - 1)) : 0,
            nameTextStyle: {
              color: '#fff'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgb(96, 98, 102)'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontFamily: 'Times New Roman'
            },
            position: i > 0 ? 'right' : 'left'
          }
        }) : {
          name: '',
          type: 'value',
          nameGap: 10,
          nameTextStyle: {
            color: '#fff'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgb(96, 98, 102)'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#fff',
            fontFamily: 'Times New Roman'
          }
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 15,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: newData.map(el => {
          let index = Object.values(yAxisMap).findIndex(item => (item.stdUnit === (el.data[0] ? el.data[0].stdUnit : '--')))
          return {
            name: el.name,
            type: 'line',
            yAxisIndex: index,
            symbol: 'none',
            data: el.data
          }
        })
      }

      chart.setOpt(chartOpt)
      chart.resize()
    },
    onChartInitialized () {
      this.initialized = true
      this.render()
    }
  },
  watch: {
    tree () {
      if (this.initialized) {
        this.render()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/07Env/01Realtime/EnvChart.vue